<template>
    <div v-if="textRight" :id="id" class="row mx-0 py-1">
        <img :src="image" class="img-overlap-top" alt="">

        <div class="card box-shadow card-overlap" style="padding-top: 2.2rem;"
             :class="{'card-overlap-top': overlapTop, 'float-right': textRight}">
            <div class="card-body row">
                <div class="col-2">
                    <div class="row">
                        <img :src="icon" height="80" class="m-auto card-logo">
                    </div>
                </div>
                <div class="col-10">
                    <p class="card-title pt-3">{{title}}</p>
                </div>
                <p class="card-text pt-2">{{text}}</p>
                <button class="btn button-gray py" v-on:click="show()">scopri di più
                </button>

            </div>
        </div>
    </div>
    <div v-else :id="id" class="row mx-0 py-1">
        <div class="card box-shadow card-overlap" style="padding-top: 2.2rem;"
             :class="{'card-overlap-top': overlapTop, 'float-right': textRight}">
            <div class="card-body row">
                <div class="col-2">
                    <div class="row">
                        <img :src="icon" height="80" class="m-auto card-logo">
                    </div>
                </div>
                <div class="col-10">
                    <p class="card-title pt-3">{{title}}</p>
                </div>
                <p class="card-text pt-2">{{text}}</p>
                <button class="btn button-gray py" v-on:click="show()">scopri di più
                </button>

            </div>
        </div>
        <img :src="image" class="img-overlap-top" alt="">
    </div>
</template>

<script>
    export default {
        name: "Card",
        props: {
            id: String,
            title: String,
            overlapTop: Boolean,
            imageName: String,
            iconName: String,
            text: String,
            textRight: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            image() {
                return require('@/assets/images/' + this.imageName)
            },
            icon() {
                return require('@/assets/images/' + this.iconName)
            }
        },
        methods: {
            show() {
                this.$modal.show('broshure', {identifier: this.id, title: this.title});
            },
            hide() {
                this.$modal.hide('broshure');
            }
        }
    }
</script>

<style scoped>

</style>